'use client';

import { Icon, Loader, Logo } from '../../components';
import { Paper } from '../../layout';
import type { LinkItem } from '../../types';

export type MagicLinkVerifyStatus = 'loading' | 'success' | 'error';

export interface MagicLinkVerifyProps {
  status: MagicLinkVerifyStatus;
  /** Title text per status */
  title: React.ReactNode;
  /** Message text per status */
  message: React.ReactNode;
  /** Link back to sign-in (shown on error) */
  signInLink?: LinkItem;
}

export function MagicLinkVerify(props: MagicLinkVerifyProps) {
  const { status, title, message, signInLink } = props;

  return (
    <div className='flex flex-col items-center gap-xl w-full max-w-md px-md sm:px-0'>
      <Logo className='h-10'></Logo>
      <Paper className='flex flex-col items-center gap-sm shadow-lg border border-border-base rounded-xl w-full p-lg sm:p-xl'>
        {status === 'loading' && (
          <div className='flex items-center justify-center w-16 h-16 mb-sm'>
            <Loader />
          </div>
        )}
        {status === 'success' && (
          <div className='flex items-center justify-center w-16 h-16 rounded-full bg-success-solid mb-sm'>
            <Icon
              name='check'
              className='text-white text-2xl stroke-current [stroke-width:32] [stroke-linejoin:round] [stroke-linecap:round]'
            />
          </div>
        )}
        {status === 'error' && (
          <div className='flex items-center justify-center w-16 h-16 rounded-full bg-error-bg mb-sm'>
            <Icon name='xmark' className='text-error-text text-2xl' />
          </div>
        )}
        <Paper.Title>{title}</Paper.Title>
        <Paper.Content className='w-full flex flex-col items-center gap-md'>
          <p className='text-foreground-muted text-center text-sm'>{message}</p>

          {status === 'error' && signInLink && (
            <a
              href={signInLink.href}
              className='text-primary-base hover:text-primary-hover flex items-center gap-xs text-sm mt-sm'
            >
              {signInLink.label}
            </a>
          )}
        </Paper.Content>
      </Paper>
    </div>
  );
}
